import { actions } from './actions'

const initialState = {
  departamentos: {
    data: [],
    loading: false,
    error: '',
  },
  departamento: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function departamentoReducer(state = initialState, action) {
  switch (action.type) {
    case actions.DEPOARTAMENTOS_LOAD_REQUESTED:
      return { ...state, departamentos: { ...state.departamentos, loading: true } }
    case actions.DEPARTAMENTOS_LOAD_SUCCEEDED:
      return {
        ...state,
        departamentos: { ...state.departamentos, data: action.payload, loading: false },
      }
    case actions.DEPARTAMENTOS_LOAD_FILED:
      return {
        ...state,
        departamentos: { ...state.departamentos, loading: false, error: action.error },
      }
    case actions.DEPARTAMENTO_UPDATE_REQUESTED:
      return {
        ...state,
        departamentos: { ...state.departamentos, loading: true, error: '' },
      }
    case actions.DEPARTAMENTO_UPDATE_SUCCEEDED:
      return {
        ...state,
        departamentos: {
          ...state.departamentos,
          data: state.departamentos.data.map(departamento =>
            departamento.id === action.payload.id ? action.payload : departamento,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.DEPARTAMENTO_UPDATE_FILED:
      return {
        ...state,
        departamentos: { ...state.departamentos, loading: false, error: action.error },
      }
    case actions.DEPARTAMENTO_INSERT_REQUESTED:
      return {
        ...state,
        departamentos: { ...state.departamentos, loading: true, error: '' },
      }
    case actions.DEPARTAMENTO_INSERT_SUCCEEDED:
      return {
        ...state,
        departamentos: {
          ...state.departamentos,
          data: [].concat(action.payload, state.departamentos.data),
          loading: false,
          error: '',
        },
      }
    case actions.DEPARTAMENTO_INSERT_FILED:
      return {
        ...state,
        departamentos: { ...state.departamentos, loading: false, error: action.error },
      }
    case actions.DEPARTAMENTO_DELETE_REQUESTED:
      return {
        ...state,
        departamentos: { ...state.departamentos, loading: true, error: '' },
      }
    case actions.DEPARTAMENTO_DELETE_SUCCEEDED:
      return {
        ...state,
        departamentos: {
          ...state.departamentos,
          data: state.departamentos.data.filter(departamento => departamento.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.DEPARTAMENTO_DELETE_FILED:
      return {
        ...state,
        departamentos: { ...state.departamentos, loading: false, error: action.error },
      }
    case actions.DEPARTAMENTO_LOAD_BY_ID_REQUESTED:
      return { ...state, departamento: { ...state.departamento, loading: true } }
    case actions.DEPARTAMENTO_LOAD_BY_ID_SUCCEEDED:
      return {
        ...state,
        departamento: { ...state.departamento, data: action.payload, loading: false },
      }
    case actions.DEPARTAMENTO_LOAD_BY_ID_FILED:
      return {
        ...state,
        departamento: { ...state.departamento, loading: false, error: action.error },
      }
    default:
      return state
  }
}
